import React from 'react';
import PdfHeaderComponent from './PdfHeaderComponent';
import { getProjectStatistics } from "../../../../apis/impact-report/report";
import useFetchData from "../../../../hooks/useFetchData";
import PdfHorizontalBarChart from "./charts/PdfHorizontalBarChart";
import Loader from "../../../../ui/Loader";
import { paginateHorizontalBarData, calculateChartDomain, generatePageTitle } from './utils/chartPagination';

const FifthPageComponent = ({ projectId, projectData }) => {
  // Fetch Impact Certificates data
  const { loading: icLoading, response: icResponse } = useFetchData(
    getProjectStatistics,
    [projectId, "BOUNTY_WISE_IMPACT_CERTIFICATE_ISSUED_COUNT", "", ""],
    [projectId, "BOUNTY_WISE_IMPACT_CERTIFICATE_ISSUED_COUNT", "", ""]
  );

  // Transform Impact Certificates data
  const impactCertificatesData = icResponse?.bountyWiseImpactCertificateIssuedCount?.map(certificate => ({
    name: certificate?.title,
    value: certificate?.impactCertificatesIssued,
    key: certificate?._id
  }))?.sort((a, b) => b?.value - a?.value) || [];

  // Paginate Impact Certificates data
  const paginatedICData = paginateHorizontalBarData(impactCertificatesData, 27);
  const icDomainData = calculateChartDomain(impactCertificatesData);

  if (icLoading) {
    return (
      <div className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
        <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
        <div className='w-full h-[23.9375rem] flex pt-11 justify-center'>
          <Loader />
        </div>
      </div>
    );
  }

  if (paginatedICData.length === 0) {
    return (
      <div className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
        <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <h2 className="text-lg font-bold text-gray-900 mb-2">Impact Certificates</h2>
          <p className="text-xs text-gray-600 mb-3">Impact certificates awarded per activity</p>
          <div className="bg-grayBgNormal p-4 rounded-lg border border-gray-200 text-center text-gray-500" style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="text-xs">No impact certificates data available</div>
          </div>
        </div>
      </div>
    );
  }

  // Render each page of Impact Certificates data
  return (
    <>
      {paginatedICData.map((pageData, pageIndex) => {
        const pageNumber = pageIndex + 1;
        const totalPages = paginatedICData.length;
        const pageTitle = generatePageTitle("Impact Certificates", pageNumber, totalPages);
        return (
          <div key={`impact-certificates-page-${pageIndex}`} className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px', height: '100vh' }}>
            <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
              <h2 className="text-lg font-bold text-gray-900 mb-2">{pageTitle}</h2>
              <p className="text-xs text-gray-600 mb-3">Impact certificates awarded per activity</p>
              
              <div className="bg-grayBgNormal p-4 rounded-lg " style={{ flex: 1, minHeight: '980px' }}>
                <PdfHorizontalBarChart
                  data={pageData}
                  xAxisLabel="Impact Certificates awarded"
                  yAxisLabel="Activities"
                  barSize={16}
                  showReferenceLine={true}
                  referenceLineValue={Math.max(...icDomainData.ticks) * 0.5}
                  domain={icDomainData.domain}
                  ticks={icDomainData.ticks}
                  showLegend={false}
                />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default FifthPageComponent;
